import React, { Suspense } from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import AppConfig from "./_appConfig";
import Navbar from "./components/Navbar";
import FooterNav from "./components/FooterNav";
import Home from "./components/Home";
import Times from "./components/Times";
import GoogleAnalytics from "./GoogleAnalytics";

import "semantic-ui-css/semantic.min.css";

class App extends React.Component {
  render() {
    return (
      <div className="wrapper">
        <GoogleAnalytics
          trackingID={AppConfig.googleAnalyticsTag}
          location={this.props.location}
          history={this.props.history}
        >
          <Suspense fallback={<div>Loading</div>}>
            <Navbar match={this.props.match} history={this.props.history} />
            <Switch>
              <Route exact path="/" component={Home} />
              <Route exact path="/times" component={Times} />
            </Switch>
            <FooterNav match={this.props.match} history={this.props.history} />
          </Suspense>
        </GoogleAnalytics>
      </div>
    );
  }
}
export default withRouter(App);
